import React, { useState } from 'react';

const styles = `
  .whois-wrap {
    padding: 28px 0;
    font-family: 'DM Sans', sans-serif;
  }
  .whois-title {
    font-size: 13px;
    font-weight: 600;
    letter-spacing: 0.08em;
    text-transform: uppercase;
    color: rgba(240,244,248,0.45);
    margin-bottom: 20px;
  }
  .whois-form {
    display: flex;
    gap: 10px;
    align-items: center;
    flex-wrap: wrap;
    margin-bottom: 20px;
  }
  .whois-input {
    flex: 1;
    min-width: 220px;
    max-width: 400px;
    padding: 11px 16px;
    border-radius: 8px;
    border: 1px solid rgba(0,173,181,0.3);
    background: rgba(0,173,181,0.07);
    color: #f0f4f8;
    font-family: 'DM Mono', monospace;
    font-size: 14px;
    outline: none;
    transition: border-color 0.2s, background 0.2s, box-shadow 0.2s;
  }
  .whois-input::placeholder { color: rgba(240,244,248,0.2); font-family: 'DM Sans', sans-serif; }
  .whois-input:focus {
    border-color: #00adb5;
    background: rgba(0,173,181,0.12);
    box-shadow: 0 0 0 3px rgba(0,173,181,0.08);
  }
  .whois-btn {
    background: #00adb5;
    border: none;
    border-radius: 8px;
    color: #fff;
    font-family: 'DM Sans', sans-serif;
    font-size: 13.5px;
    font-weight: 600;
    padding: 11px 22px;
    cursor: pointer;
    transition: background 0.2s, box-shadow 0.2s, transform 0.2s;
    white-space: nowrap;
  }
  .whois-btn:hover { background: #009aa2; box-shadow: 0 4px 14px rgba(0,173,181,0.35); transform: translateY(-1px); }
  .whois-btn:active { transform: translateY(0); }
  .whois-btn:disabled { opacity: 0.5; cursor: not-allowed; transform: none; }

  .whois-history {
    display: flex;
    flex-direction: column;
    gap: 8px;
  }
  .whois-history-title {
    font-size: 11px;
    font-weight: 600;
    letter-spacing: 0.1em;
    text-transform: uppercase;
    color: rgba(240,244,248,0.3);
    margin-bottom: 4px;
  }
  .whois-history-item {
    display: flex;
    align-items: center;
    justify-content: space-between;
    background: rgba(255,255,255,0.03);
    border: 1px solid rgba(255,255,255,0.06);
    border-radius: 8px;
    padding: 10px 14px;
    gap: 12px;
    transition: background 0.2s, border-color 0.2s;
  }
  .whois-history-item:hover {
    background: rgba(0,173,181,0.06);
    border-color: rgba(0,173,181,0.2);
  }
  .whois-history-domain {
    font-family: 'DM Mono', monospace;
    font-size: 13.5px;
    color: #f0f4f8;
  }
  .whois-history-actions {
    display: flex;
    gap: 8px;
    flex-shrink: 0;
  }
  .whois-link {
    display: inline-flex;
    align-items: center;
    gap: 5px;
    background: rgba(0,173,181,0.1);
    border: 1px solid rgba(0,173,181,0.25);
    border-radius: 6px;
    color: #00adb5;
    font-family: 'DM Sans', sans-serif;
    font-size: 12px;
    font-weight: 500;
    padding: 5px 11px;
    cursor: pointer;
    text-decoration: none;
    transition: background 0.2s, border-color 0.2s;
  }
  .whois-link:hover { background: rgba(0,173,181,0.18); border-color: rgba(0,173,181,0.45); }
  .whois-remove {
    background: transparent;
    border: 1px solid transparent;
    border-radius: 6px;
    color: rgba(240,244,248,0.25);
    font-size: 14px;
    width: 28px; height: 28px;
    display: flex; align-items: center; justify-content: center;
    cursor: pointer;
    transition: background 0.2s, color 0.2s, border-color 0.2s;
  }
  .whois-remove:hover {
    background: rgba(255,87,34,0.1);
    border-color: rgba(255,87,34,0.3);
    color: #ff7043;
  }
  .whois-hint {
    font-size: 12px;
    color: rgba(240,244,248,0.28);
    line-height: 1.6;
    margin-top: 6px;
  }
  .whois-empty {
    font-size: 13px;
    color: rgba(240,244,248,0.25);
    padding: 20px 0;
    text-align: center;
  }
`;

export default function WhoisChecker() {
  const [value, setValue]     = useState('');
  const [history, setHistory] = useState([]);

  const open = (domain) => {
    const d = domain.trim().toLowerCase();
    if (!d) return;
    window.open(`https://registro.br/tecnologia/ferramentas/whois/?search=${encodeURIComponent(d)}`, '_blank', 'noopener');
    // Adiciona ao histórico se ainda não estiver
    setHistory((prev) =>
      prev.find((h) => h === d) ? prev : [d, ...prev].slice(0, 20)
    );
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (value.trim()) {
      open(value);
      setValue('');
    }
  };

  const handleRemove = (domain) => {
    setHistory((prev) => prev.filter((h) => h !== domain));
  };

  return (
    <>
      <style>{styles}</style>
      <div className="whois-wrap">
        <div className="whois-title">Consultar Whois</div>

        <form className="whois-form" onSubmit={handleSubmit}>
          <input
            className="whois-input"
            type="text"
            placeholder="dominio.com.br"
            value={value}
            onChange={(e) => setValue(e.target.value)}
            autoComplete="off"
            spellCheck={false}
          />
          <button className="whois-btn" type="submit" disabled={!value.trim()}>
            Consultar no Registro.br ↗
          </button>
        </form>

        <p className="whois-hint">
          Abre o Whois oficial do Registro.br em nova aba. Pressione Enter ou clique em Consultar.
        </p>

        {history.length > 0 && (
          <div className="whois-history" style={{ marginTop: 28 }}>
            <div className="whois-history-title">Consultados recentemente</div>
            {history.map((domain) => (
              <div className="whois-history-item" key={domain}>
                <span className="whois-history-domain">{domain}</span>
                <div className="whois-history-actions">
                  <a
                    className="whois-link"
                    href={`https://registro.br/tecnologia/ferramentas/whois/?search=${encodeURIComponent(domain)}`}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    ↗ Abrir
                  </a>
                  <button className="whois-remove" onClick={() => handleRemove(domain)} title="Remover">✕</button>
                </div>
              </div>
            ))}
          </div>
        )}

        {history.length === 0 && (
          <div className="whois-empty">Nenhuma consulta realizada ainda.</div>
        )}
      </div>
    </>
  );
}
